<template>
    <div class="daigou-create">
        <div class="main-body">
            <Icon class="close-ico" type="md-close" @click="onClose" />
            <div class="main-header">代购入仓</div>
            <div class="main-body-form">
                <div class="material-info">
                    <div class="title">物料信息</div>
                    <div class="info">
                        <img :src="material.image|default_img" alt="" class="fabric-cover" />
                        <div class="fabric-info">
                            <div class="fabric-name">{{ material.name }}</div>
                            <div class="info-item">编号:{{ material.no }}</div>
                            <div class="info-item">成分:{{ material.component }}</div>
                        </div>
                    </div>
                </div>
                <div class="title">代购需求</div>
                <div class="form-body">
                    <div class="form-item">
                        <div class="form-item-label required">代购颜色及数量</div>
                        <div class="form-item-value-multiple">
                            <div class="value-item" v-for="(item, index) in form.wuliao_json" :key="`value-item-${index}`">
                                <div class="item-left">
                                    <img :src="item.image | default_img" alt="" class="color-img" />
                                    <div class="color-name">{{ item.name }}</div>
                                </div>
                                <div class="item-right">
                                    <input type="number" min="0" step="0.01" v-model="item.send" placeholder="代购数量" />
                                    <div class="input-unit">{{ form.unit }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- 期望价格：先隐藏，后续需要时放开此处注释即可
                    <div class="form-item form-col-2">
                        <div class="form-item-label">期望价格（元）</div>
                        <div class="form-item-value-single">
                            <Input type="number" placeholder="选填，可先与采购人员沟通议价" v-model="form.expect_price" />
                        </div>
                    </div>
                    -->
                    <div class="form-item">
                        <div class="form-item-label">需求说明</div>
                        <div class="form-item-value-single">
                            <Input placeholder="请描述交期等需求，便于采购人员采购" v-model="form.remark" type="textarea" :rows="3" />
                        </div>
                    </div>
                </div>
                <div class="daigou-tip">提交后将由平台采购人员确认金额，确认后您可在「我的代购订单」中在线支付。</div>
            </div>
            <div class="main-footer">
                <div class="cancel-btn" @click="onClose">取消</div>
                <div class="confirm-btn" :class="{ disabled: submitting }" @click="onSubmit">{{ submitting ? '提交中...' : '提交代购' }}</div>
            </div>
        </div>
    </div>
</template>
<script>
import { CreateDesignDaigouOrder } from "@/api/daigou";
export default {
    name: "DaigouCreate",
    props: {
        material: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            submitting: false,
            form: {
                unit: 'm',
                wuliao_json: [],
                expect_price: '',
                remark: ''
            }
        }
    },
    mounted() {
        if (!this.material.uuid) {
            this.$layer.msg('物料不存在~');
            this.onClose();
            return;
        }
        // 单位按物料类型区分：面料按米(m)，辅料按个(个)，避免辅料误用 m
        this.form.unit = this.material.type == 2 ? '个' : 'm';
        // 与「自己发货入仓」一致：按颜色逐项填写代购数量
        const colorList = this.material.color || [];
        this.form.wuliao_json = colorList.length
            ? colorList.map((item) => ({
                color_id: item.id,
                uuid: item.uuid,
                name: item.name,
                image: item.image,
                send: 0
            }))
            : [{ color_id: 0, uuid: '', name: '默认', image: this.material.image || '', send: 0 }];
    },
    methods: {
        async onSubmit() {
            if (this.submitting) return;
            // 数量统一转为数字并保留两位小数，避免字符串 / NaN 直接提交给后端
            const wuliao_json = (this.form.wuliao_json || []).map((c) => {
                const n = Number(c.send || 0);
                return {
                    color_id: c.color_id,
                    uuid: c.uuid,
                    name: c.name,
                    image: c.image,
                    send: Number.isFinite(n) ? Math.round(n * 100) / 100 : 0
                };
            });
            let hasNegative = false;
            let hasTooLarge = false;
            const totalSend = wuliao_json.reduce((sum, c) => {
                if (c.send < 0) hasNegative = true;
                if (c.send > 999999) hasTooLarge = true;
                return sum + c.send;
            }, 0);
            if (hasNegative) {
                this.$layer.msg('代购数量不能为负数');
                return;
            }
            if (hasTooLarge) {
                this.$layer.msg('单个颜色的代购数量不能超过 999999');
                return;
            }
            if (totalSend <= 0) {
                this.$layer.msg('请填写代购颜色及数量');
                return;
            }
            const expectPrice = Number(this.form.expect_price || 0);
            if (expectPrice < 0) {
                this.$layer.msg('期望价格不能为负数');
                return;
            }
            this.submitting = true;
            try {
                const { code, msg } = await CreateDesignDaigouOrder({
                    material_uuid: this.material.uuid,
                    material_type: this.material.type == 2 ? 2 : 1,
                    wuliao_json: wuliao_json,
                    unit: this.form.unit || 'm',
                    expect_price: this.form.expect_price,
                    remark: this.form.remark
                });
                if (code > 0) {
                    this.$layer.msg(msg);
                    return;
                }
                // 由父组件统一处理：提示并跳转到「我的代购订单」
                this.$emit('success');
            } catch (e) {
                console.log('err-daigou-create', e);
                this.$layer.msg(e.msg || '提交失败');
            } finally {
                this.submitting = false;
            }
        },
        onClose() {
            this.$emit("close");
        }
    }
}
</script>
<style lang="scss" scoped>
.daigou-create {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, .5);
    z-index: 110;
    display: flex;
    align-items: center;
    justify-content: center;
    .main-body {
        width: 640px;
        background: #fff;
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        position: relative;
        .close-ico {
            position: absolute;
            top: 14px;
            right: 16px;
            font-size: 18px;
            cursor: pointer;
        }
        .main-header {
            width: 100%;
            border-bottom: 1px solid #e0e0e0;
            padding: 20px 0 12px;
            text-align: center;
            font-size: 20px;
            font-weight: bold;
            color: #0f1115;
            margin-bottom: 20px;
        }
        .main-body-form {
            width: 100%;
            padding: 0 24px;
            .material-info {
                margin-bottom: 20px;
                .info {
                    border: 1px solid #e3e3e3;
                    border-radius: 6px;
                    display: flex;
                    column-gap: 16px;
                    width: 100%;
                    padding: 10px;
                    .fabric-cover {
                        width: 80px;
                        height: 80px;
                        border: 1px solid #e3e3e3;
                        border-radius: 8px;
                    }
                    .fabric-info {
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                        .fabric-name {
                            font-size: 14px;
                            color: #333;
                            font-weight: bold;
                            margin-bottom: 8px;
                        }
                        .info-item {
                            color: #666;
                            font-size: 14px;
                        }
                    }
                }
            }
            .title {
                width: 100%;
                font-weight: bold;
                color: #333;
                font-size: 16px;
                margin-bottom: 12px;
            }
            .form-body {
                width: 100%;
                background: #f6f7f9;
                border-radius: 6px;
                padding: 16px 18px 22px 18px;
                display: flex;
                flex-wrap: wrap;
                column-gap: 13px;
                row-gap: 24px;
                margin-bottom: 16px;
                .form-item {
                    display: flex;
                    flex-direction: column;
                    row-gap: 10px;
                    width: 100%;
                    &.form-col-2 {
                        width: calc(100% / 2 - 13px);
                    }
                    .form-item-label {
                        color: #333;
                        font-size: 14px;
                        &.required::after {
                            content: "*";
                            color: red;
                        }
                    }
                    .form-item-value-single {
                        width: 100%;
                    }
                    .form-item-value-multiple {
                        display: flex;
                        flex-wrap: wrap;
                        gap: 13px;
                        .value-item {
                            width: calc(100% / 2 - 13px);
                            display: flex;
                            align-items: center;
                            border: 1px solid #e3e3e3;
                            border-radius: 4px;
                            background: #fff;
                            .item-left {
                                display: flex;
                                align-items: center;
                                column-gap: 7px;
                                border-right: 1px solid #e3e3e3;
                                padding: 5px;
                                width: 50%;
                                .color-img {
                                    width: 32px;
                                    height: 32px;
                                    border: 1px solid #e3e3e3;
                                    border-radius: 4px;
                                }
                                .color-name {
                                    color: #333;
                                    font-size: 14px;
                                    white-space: nowrap;
                                    text-overflow: ellipsis;
                                    overflow: hidden;
                                }
                            }
                            .item-right {
                                display: flex;
                                align-items: center;
                                padding: 0 10px;
                                width: 50%;
                                input {
                                    border: none;
                                    outline: none;
                                    width: 90%;
                                }
                                .input-unit {
                                    color: #333;
                                    font-size: 14px;
                                }
                            }
                        }
                    }
                }
            }
            .daigou-tip {
                color: #999;
                font-size: 12px;
                margin-bottom: 20px;
            }
        }
        .main-footer {
            width: 100%;
            border-top: 1px solid #e0e0e0;
            display: flex;
            align-items: center;
            justify-content: center;
            column-gap: 10px;
            padding: 18px 0 22px;
            .cancel-btn {
                color: #666;
                font-size: 14px;
                font-weight: bold;
                cursor: pointer;
                height: 40px;
                line-height: 40px;
                border: 1px solid #e3e3e3;
                border-radius: 4px;
                padding: 0 36px;
            }
            .confirm-btn {
                color: #fff;
                font-size: 14px;
                font-weight: bold;
                cursor: pointer;
                height: 40px;
                line-height: 40px;
                border: 1px solid #e3e3e3;
                border-radius: 4px;
                padding: 0 40px;
                background: #ff5967;
                &.disabled {
                    opacity: 0.6;
                    cursor: not-allowed;
                }
            }
        }
    }
}
</style>
